var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoauthorLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-3 -2 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.37 1.47a1.337 1.337 0 012.673 0v.114a1.337 1.337 0 11-2.674 0v-.113zm8.031.353a1.337 1.337 0 10-2.674 0v7.724a1.337 1.337 0 002.674 0V1.823zM3.244 5.931a1.433 1.433 0 00-2.865 0v6.495a1.433 1.433 0 002.865 0V5.93zm2.483 8.484a1.337 1.337 0 012.674 0v.114a1.337 1.337 0 01-2.674 0v-.114zm8.022-9.542a1.337 1.337 0 00-2.674 0v.114a1.337 1.337 0 102.674 0v-.114zm0 4.59a1.337 1.337 0 00-2.673 0v3.057a1.337 1.337 0 002.674 0V9.463z",
    fill: "url(#coauthor-logo_svg__paint0_linear_169_6562)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "coauthor-logo_svg__paint0_linear_169_6562",
    x1: 13.75,
    y1: 0.133,
    x2: -1.779,
    y2: 13.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FD7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    stopColor: "#0895DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#6759FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93F"
  })))));
}
export default SvgCoauthorLogo;